import {React, useState} from 'react'

import {useTranslation} from "react-i18next";
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
    intern_toggle_show_small_station_labels,
    intern_toggle_show_medium_station_labels,
    intern_toggle_show_large_station_labels,
    intern_toggle_show_line_labels,
    intern_toggle_panel_left_open,
    intern_toggle_modal_origin_destination_open,
    intern_toggle_modal_color_open, intern_reset_all, intern_set_is_authenticated,
} from "../../actions";
import {connect, useDispatch, useSelector} from "react-redux";
import InternToggleSwitch from "./InternToggleSwitch";
import axios from "axios";
import {AUTH_URLS} from "../../utils/AppConfig";
import InternLanguageChooser from "./InternLanguageChooser";


const InternLeftPanel = (props) => {
	const { t, i18n } = useTranslation();
    const dispatch = useDispatch()

    const handleToggleSmallLabels = () => {
        dispatch(intern_toggle_show_small_station_labels(!props.show_small_station_labels))
    }
    const handleToggleMediumLabels = () => {
        dispatch(intern_toggle_show_medium_station_labels(!props.show_medium_station_labels))
    }
    const handleToggleLargeLabels = () => {
        dispatch(intern_toggle_show_large_station_labels(!props.show_large_station_labels))
    }
    const handleToggleLineLabels = () => {
        dispatch(intern_toggle_show_line_labels(!props.show_line_labels))
    }

    const modal_origin_destination_open = useSelector(state => state.general.intern_ui.modal_origin_destination_open)
    const modal_color_open = useSelector(state => state.general.intern_ui.modal_color_open)
    const override_color_bg = useSelector(state => state.general.intern_config.override_color_bg)



    const toggle_origin_destination_clicked = (e) => {
        e.preventDefault()
        const new_modal_origin_destination_open = modal_origin_destination_open ? false : true
        dispatch(intern_toggle_modal_origin_destination_open(new_modal_origin_destination_open))
    }

    const toggle_modal_color_open_clicked = (e) => {
        e.preventDefault()
        const new_modal_color_open = modal_color_open ? false : true
        dispatch(intern_toggle_modal_color_open(new_modal_color_open))
    }

    const reset_clicked = (e) => {
        e.preventDefault()
        dispatch(intern_reset_all())
    }

    const logout_clicked = async (e) => {
        e.preventDefault();
        try {
            const response_login = await axios.post(AUTH_URLS.LOGOUT, {});

            const {
                is_authenticated,
            } = response_login.data;

            if(!is_authenticated) {
                dispatch(intern_set_is_authenticated(is_authenticated))
            }

        } catch (error) {
            const message = error.response?.data?.message || t('Logout fehlgeschlagen');
            console.error('Problem in logout: ', message)
        }
    }

    const btn_modal_origin_destination_cls = modal_origin_destination_open ? 'button-intern mode-active' : 'button-intern'
    const btn_modal_color_cls = modal_color_open ? 'button-intern mode-active' : 'button-intern'

    const override_color_value = override_color_bg === null? 'unset': override_color_bg;
    const override_color_cls = override_color_bg === null? 'color-0': '';


	return (

		<nav className="panel-left panel-left-open">
            <PerfectScrollbar className="nav-content-scrollable" >

                <div className="nav-main">
                    <div className="nav-section nav-section-title">
                        <div className="title">
                            {t("INTERN Fernverkehr")}
                        </div>
                        <div className={'intern-panel-section intern-settings text'}>
                            <header className={'panel-left-section-header'}>
                                {t('Einstellungen')}
                            </header>
                            <div className={'settings-item'}>
                                <div className={'settings-item-label'}>{t('Labels "Kleine Bahnhöfe" anzeigen')}</div>
                                <InternToggleSwitch isChecked={props.show_small_station_labels} handleToggle={handleToggleSmallLabels} />
                            </div>
                            <div className={'settings-item'}>
                                <div className={'settings-item-label'}>{t('Labels "Mittlere Bahnhöfe" anzeigen')}</div>
                                <InternToggleSwitch isChecked={props.show_medium_station_labels} handleToggle={handleToggleMediumLabels} />
                            </div>
                            <div className={'settings-item'}>
                                <div className={'settings-item-label'}>{t('Labels "Grosse Bahnhöfe" anzeigen')}</div>
                                <InternToggleSwitch isChecked={props.show_large_station_labels} handleToggle={handleToggleLargeLabels} />
                            </div>
                            <div className={'settings-item'}>
                                <div className={'settings-item-label'}>{t('Linienlabels anzeigen')}</div>
                                <InternToggleSwitch isChecked={props.show_line_labels} handleToggle={handleToggleLineLabels} />
                            </div>
                        </div>

                        <div className="intern-panel-section text">
                            <header className={'panel-left-section-header'}>
                                {t("Anleitung")}
                            </header>
                            <div className={'text'}>
                                {t('Klick auf die Linie aktiviert/deaktiviert einzelne Liniensegmente')}
                            </div>
                            <div className={'text'}>
                                {t('Klick auf das Linienlabel aktiviert/deaktiviert die ganze Linie')}
                            </div>
                            <div className={'text'}>
                                {t('Klick auf das Bahnhofslabel/Icon blendet das einzelne Label aus/ein')}
                            </div>
                        </div>

                        <div className="intern-panel-section mobile-only">
                            <header className={'panel-left-section-header'}>
                                {t("Mobile Buttons")}
                            </header>
                            <div className={'intern-left-panel-nav'}>
                                <button type="button" className={btn_modal_origin_destination_cls} onClick={toggle_origin_destination_clicked}>
                                    <div className={'button-bg'}></div>
                                    <div className={'button-text'}>{t('Start / Ziel')}</div>
                                </button>
                                <button type="button" className={`${btn_modal_color_cls} color-button`} onClick={toggle_modal_color_open_clicked}>
                                    <div className={'button-bg'}></div>
                                    <div className={'button-text'}>{t('Farbe')}</div>
                                    <div className={'selected-color'}>
                                        <div className={`color-circle ${override_color_cls}`} style={{backgroundColor: override_color_value}}></div>
                                    </div>
                                </button>
                                <button type="button" className={'button-intern'} onClick={reset_clicked}>
                                    <div className={'button-bg'}></div>
                                    <div className={'button-text'}>{t('Reset')}</div>
                                </button>
                                <button type="button" className={'button-intern logout-button'} onClick={logout_clicked}>
                                    <div className={'button-bg'}></div>
                                    <div className={'button-text'}>{t('Abmelden')}</div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nav-bottom">

                    {/*<div className="nav-section nav-section-disclaimer">*/}
                    {/*            <span className="text">*/}
                    {/*                {t("Disclaimer:")}*/}
                    {/*                <br />{t("disclaimer-valid-info")}*/}
                    {/*                <br />{t("Alle Angaben, Anschlüsse und Einhaltung des Fahrplans ohne Gewähr. Informieren Sie sich kurz vor Abfahrt über mögliche Änderungen.")}*/}
                    {/*                <br />*/}
                    {/*                <br />*/}
                    {/*                <button className="content-link-button ot-sdk-show-settings">*/}
                    {/*                        <span className="text">{t("Cookie-Einstellungen")}</span>*/}
                    {/*                </button>*/}
                    {/*            </span>*/}

                    {/*</div>*/}
                    <div className="nav-section nav-section-language-selector">
                        <span className="visuallyhidden">{t("Sprache wählen")}</span>
                        <InternLanguageChooser />
                    </div>
                </div>
            </PerfectScrollbar>

		</nav>
	)
}

const map_state_to_props = state => {
    return {
        show_small_station_labels: state.general.intern_config.show_small_station_labels,
        show_medium_station_labels: state.general.intern_config.show_medium_station_labels,
        show_large_station_labels: state.general.intern_config.show_large_station_labels,
        show_line_labels: state.general.intern_config.show_line_labels,
    }
}

export default connect(map_state_to_props)(InternLeftPanel)